import {
  EnderecoDtoCreate,
  EnderecoDtoUpdate,
  EnderecoList,
  EnderecoView,
} from '../../../empresa/empresas-list/core/_models'
import {
  createEnderecoEmpresa,
  getEnderecoByIdEmpresa,
  updateEnderecoEmpresa,
} from '../../../empresa/empresas-list/core/_requests'
import {
  createUnidadeEndereco,
  getUnidadeEnderecos,
  updateUnidadeEndereco,
} from '../../../unidades/unidades-list/core/_requests'

/**
 * De onde a listagem de endereços foi aberta. Instituição e Entidade são a mesma entidade no
 * backend (`Empresa`) e usam os mesmos endpoints — a distinção existe só para rotular a tela com
 * o mesmo nome da listagem de origem, já que o usuário chega aqui por menus diferentes.
 */
export type OrigemEndereco = 'instituicao' | 'entidade' | 'unidade'

const ORIGENS: OrigemEndereco[] = ['instituicao', 'entidade', 'unidade']

export const isOrigemEndereco = (valor?: string): valor is OrigemEndereco =>
  !!valor && ORIGENS.includes(valor as OrigemEndereco)

export const isOrigemEmpresa = (origem: OrigemEndereco) => origem !== 'unidade'

export const getEnderecosDaOrigem = (
  origem: OrigemEndereco,
  idOrigem: number
): Promise<EnderecoList[]> =>
  isOrigemEmpresa(origem) ? getEnderecoByIdEmpresa(idOrigem) : getUnidadeEnderecos(idOrigem)

export const createEnderecoDaOrigem = (
  origem: OrigemEndereco,
  idOrigem: number,
  endereco: EnderecoDtoCreate
): Promise<EnderecoView> =>
  isOrigemEmpresa(origem)
    ? createEnderecoEmpresa(idOrigem, endereco)
    : createUnidadeEndereco(idOrigem, endereco)

export const updateEnderecoDaOrigem = (
  origem: OrigemEndereco,
  idOrigem: number,
  endereco: EnderecoDtoUpdate
): Promise<EnderecoView> =>
  isOrigemEmpresa(origem)
    ? updateEnderecoEmpresa(idOrigem, endereco)
    : updateUnidadeEndereco(idOrigem, endereco)
